import moment from 'moment'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {convertToMoment} from '../../../../../components/reservations/helpers/helpers'
import {RESIDENT_APPLY_HISTORY_DIVISION, RESIDENT_APPLY_STATUS} from '../../../../../CodeMaster'

export const getApplicant = (
    ridgeName: string,
    roomNumber: string,
    familyName: string,
    firstName: string
): string => {
    const applicant = ridgeName
        + ' '
        + convertToRoomNumberForResident(roomNumber)
        + '　'
        + familyName
        + ' '
        + firstName

    return applicant
}

export const getPrintDate = (
    date: string
): { year: string, month: string, day: string } => {
    const formatDate: string = moment(date).format(('YYYY-M-D'))
    const splitDate = formatDate.split('-')

    return {
        year: splitDate[0], month: splitDate[1], day: splitDate[2]
    }
}

export const getPrintTime = (
    date: string,
    time: string
): { hours: string, minutes: string } => {
    const formatDate: string = convertToMoment(date, time).format('H:mm')
    const splitTime = formatDate.split(':')
    return {
        hours: splitTime[0], minutes: splitTime[1]
    }
}

export const convertApplyStatusIntoApplyHistoryDivision = (
    applyStatus: string
): RESIDENT_APPLY_HISTORY_DIVISION => {
    if (applyStatus === RESIDENT_APPLY_STATUS.COMPLETE.value) {
        return RESIDENT_APPLY_HISTORY_DIVISION.APPROVED
    } else if (applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value) {
        return RESIDENT_APPLY_HISTORY_DIVISION.REJECTION
    } else {
        return RESIDENT_APPLY_HISTORY_DIVISION.APPROVAL_WAITING
    }
}